import { apiRequest } from '@/utils/api-request';

export interface AuthMethod {
  type: 'sso' | 'otp';
  provider?: string;
  org_name?: string;
  org_logo_url?: string;
  auth0_org_id?: string;
  connection?: string;
}

export interface AuthDiscoverResponse {
  methods: AuthMethod[];
}

export const authDiscover = async (email: string) => {
  const response = await apiRequest<AuthDiscoverResponse>({
    url: '/public/auth/discover',
    method: 'POST',
    target: 'platform',
    body: { email: email.toLowerCase() },
  });

  if (response && 'detail' in response) {
    return { detail: response.detail || 'Failed to discover auth method' };
  }

  return response;
};
